export var kk;
(function (kk) {
    kk.names = {
        AD: "Андорра",
        AE: "Біріккен Араб Әмірліктері",
        AF: "Ауғанстан",
        AG: "Антигуа және Барбуда",
        AI: "Ангилья",
        AL: "Албания",
        AM: "Армения",
        AO: "Ангола",
        AQ: "Антарктида",
        AR: "Аргентина",
        AS: "Америкалық Самоа",
        AT: "Австрия",
        AU: "Австралия",
        AW: "Аруба",
        AX: "Аланд аралдары",
        AZ: "Әзірбайжан",
        BA: "Босния және Герцеговина",
        BB: "Барбадос",
        BD: "Бангладеш",
        BE: "Бельгия",
        BF: "Буркина-Фасо",
        BG: "Болгария",
        BH: "Бахрейн",
        BI: "Бурунди",
        BJ: "Бенин",
        BL: "Сен-Бартелеми",
        BM: "Бермуд аралдары",
        BN: "Бруней",
        BO: "Боливия",
        BQ: "Кариб Нидерландысы",
        BR: "Бразилия",
        BS: "Багам аралдары",
        BT: "Бутан",
        BV: "Буве аралы",
        BW: "Ботсвана",
        BY: "Беларусь",
        BZ: "Белиз",
        CA: "Канада",
        CC: "Кокос (Килинг) аралдары",
        CD: "Конго",
        CF: "Орталық Африка Республикасы",
        CG: "Конго Республикасы",
        CH: "Швейцария",
        CI: "Кот-д’Ивуар",
        CK: "Кук аралдары",
        CL: "Чили",
        CM: "Камерун",
        CN: "Қытай",
        CO: "Колумбия",
        CR: "Коста-Рика",
        CU: "Куба",
        CV: "Кабо-Верде",
        CW: "Кюрасао",
        CX: "Рождество аралы",
        CY: "Кипр",
        CZ: "Чех Республикасы",
        DE: "Германия",
        DJ: "Джибути",
        DK: "Дания",
        DM: "Доминика",
        DO: "Доминикан Республикасы",
        DZ: "Алжир",
        EC: "Эквадор",
        EE: "Эстония",
        EG: "Мысыр",
        EH: "Батыс Сахара",
        ER: "Эритрея",
        ES: "Испания",
        ET: "Эфиопия",
        FI: "Финляндия",
        FJ: "Фиджи",
        FK: "Фолкленд аралдары",
        FM: "Микронезия",
        FO: "Фарер аралдары",
        FR: "Франция",
        GA: "Габон",
        GB: "Ұлыбритания",
        GD: "Гренада",
        GE: "Грузия",
        GF: "Француз Гвианасы",
        GG: "Гернси",
        GH: "Гана",
        GI: "Гибралтар",
        GL: "Гренландия",
        GM: "Гамбия",
        GN: "Гвинея",
        GP: "Гваделупа",
        GQ: "Экваторлық Гвинея",
        GR: "Грекия",
        GS: "Оңтүстік Георгия және Оңтүстік Сандвич аралдары",
        GT: "Гватемала",
        GU: "Гуам",
        GW: "Гвинея-Бисау",
        GY: "Гайана",
        HK: "Гонконг",
        HM: "Херд аралы және Макдональд аралдары",
        HN: "Гондурас",
        HR: "Хорватия",
        HT: "Гаити",
        HU: "Венгрия",
        ID: "Индонезия",
        IE: "Ирландия",
        IL: "Израиль",
        IM: "Мэн аралы",
        IN: "Үндістан",
        IO: "Үнді мұхитындағы Британ аймағы",
        IQ: "Ирак",
        IR: "Иран",
        IS: "Исландия",
        IT: "Италия",
        JE: "Джерси",
        JM: "Ямайка",
        JO: "Иордания",
        JP: "Жапония",
        KE: "Кения",
        KG: "Қырғызстан",
        KH: "Камбоджа",
        KI: "Кирибати",
        KM: "Комор аралдары",
        KN: "Сент-Китс және Невис",
        KP: "Солтүстік Корея",
        KR: "Оңтүстік Корея",
        KW: "Кувейт",
        KY: "Кайман аралдары",
        KZ: "Қазақстан",
        LA: "Лаос",
        LB: "Ливан",
        LC: "Сент-Люсия",
        LI: "Лихтенштейн",
        LK: "Шри-Ланка",
        LR: "Либерия",
        LS: "Лесото",
        LT: "Литва",
        LU: "Люксембург",
        LV: "Латвия",
        LY: "Ливия",
        MA: "Марокко",
        MC: "Монако",
        MD: "Молдова",
        ME: "Черногория",
        MF: "Сен-Мартен",
        MG: "Мадагаскар",
        MH: "Маршалл аралдары",
        MK: "Македония Республикасы",
        ML: "Мали",
        MM: "Мьянма (Бирма)",
        MN: "Моңғолия",
        MO: "Макао",
        MP: "Солтүстік Мариана аралдары",
        MQ: "Мартиника",
        MR: "Мавритания",
        MS: "Монтсеррат",
        MT: "Мальта",
        MU: "Маврикий",
        MV: "Мальдив аралдары",
        MW: "Малави",
        MX: "Мексика",
        MY: "Малайзия",
        MZ: "Мозамбик",
        NA: "Намибия",
        NC: "Жаңа Каледония",
        NE: "Нигер",
        NF: "Норфолк аралы",
        NG: "Нигерия",
        NI: "Никарагуа",
        NL: "Нидерланд",
        NO: "Норвегия",
        NP: "Непал",
        NR: "Науру",
        NU: "Ниуэ",
        NZ: "Жаңа Зеландия",
        OM: "Оман",
        PA: "Панама",
        PE: "Перу",
        PF: "Француз Полинезиясы",
        PG: "Папуа — Жаңа Гвинея",
        PH: "Филиппин",
        PK: "Пәкістан",
        PL: "Польша",
        PM: "Сен-Пьер және Микелон",
        PN: "Питкэрн аралдары",
        PR: "Пуэрто-Рико",
        PS: "Палестина аймақтары",
        PT: "Португалия",
        PW: "Палау",
        PY: "Парагвай",
        QA: "Катар",
        RE: "Реюньон",
        RO: "Румыния",
        RS: "Сербия",
        RU: "Ресей",
        RW: "Руанда",
        SA: "Сауд Арабиясы",
        SB: "Соломон аралдары",
        SC: "Сейшель аралдары",
        SD: "Судан",
        SE: "Швеция",
        SG: "Сингапур",
        SH: "Әулие Елена аралы",
        SI: "Словения",
        SJ: "Шпицберген және Ян-Майен",
        SK: "Словакия",
        SL: "Сьерра-Леоне",
        SM: "Сан-Марино",
        SN: "Сенегал",
        SO: "Сомали",
        SR: "Суринам",
        SS: "Оңтүстік Судан",
        ST: "Сан-Томе және Принсипи",
        SV: "Сальвадор",
        SX: "Синт-Мартен",
        SY: "Сирия",
        SZ: "Свазиленд",
        TC: "Теркс және Кайкос аралдары",
        TD: "Чад",
        TF: "Францияның оңтүстік аймақтары",
        TG: "Того",
        TH: "Тайланд",
        TJ: "Тәжікстан",
        TK: "Токелау",
        TL: "Тимор-Лесте",
        TM: "Түрікменстан",
        TN: "Тунис",
        TO: "Тонга",
        TR: "Түркия",
        TT: "Тринидад және Тобаго",
        TV: "Тувалу",
        TW: "Тайвань",
        TZ: "Танзания",
        UA: "Украина",
        UG: "Уганда",
        UM: "АҚШ-тың сыртқы кіші аралдары",
        US: "Америка Құрама Штаттары",
        UY: "Уругвай",
        UZ: "Өзбекстан",
        VA: "Ватикан",
        VC: "Сент-Винсент және Гренадин аралдары",
        VE: "Венесуэла",
        VG: "Британдық Виргин аралдары",
        VI: "АҚШ-тың Виргин аралдары",
        VN: "Вьетнам",
        VU: "Вануату",
        WF: "Уоллис және Футуна",
        WS: "Самоа",
        XK: "Косово",
        YE: "Йемен",
        YT: "Майотта",
        ZA: "Оңтүстік Африка Республикасы",
        ZM: "Замбия",
        ZW: "Зимбабв",
    };
})(kk || (kk = {}));
//# sourceMappingURL=kk.js.map